import { hasPermission } from './Permissions';

export function hasQuotesPermission(permission) {
    return hasPermission(permission);
}

export function hasAnyQuotesMenuAccess() {
    const viewPermissions = [
        'quotes.applications.view',
        'quotes.policies.view',
        'quotes.scheduled_appointments.view',
        'quotes.commissions.view',
        'quotes.commissions.view_any',
    ];

    return viewPermissions.some((name) => hasQuotesPermission(name));
}

export function hasAnyQuotesCotizacionesSubmenuAccess() {
    return [
        'quotes.applications.view',
        'quotes.policies.view',
        'quotes.scheduled_appointments.view',
    ].some((name) => hasQuotesPermission(name));
}
